import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import React, { useEffect, useState } from "react";
// import FormControl, { useFormControlContext } from "@mui/base/FormControl";
import DownloadIcon from "@mui/icons-material/Download";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import DialogActions from "@mui/material/DialogActions";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from "@mui/material/FormHelperText";
import Grid from "@mui/material/Grid";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import axios from "axios";
import { format } from "date-fns";
import { saveAs } from "file-saver";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setIsNewAssessment } from "../features/flagSlice";
import { setNewAssessmentData } from "../features/newAssessmentSlice";
import { assessmentPopupCall } from "../features/popupSlice";
import {
  setFinalWorkspaceData,
  setWorkspaceInitialData,
} from "../features/workspaceDataSlice";
import { numericValidation } from "../service/Service";
import { NEWASSESSMENTPOPUP_URL } from "../service/data";
import ErrorHandler from "./ErrorHandler";
import FileUploader from "./FileUploader";
import { setWorkspaceDataSaveSuccess } from "../features/workspaceDataSlice";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  overflow: "scroll",
  height: 500,
  display: "block",
  marginTop: "50px",
};

const NewAssessmentPopup = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const { accessToken, userInfo } = useSelector((state) => state.user);
  const [assessmentSubmitted, setAssessmentSubmitted] = useState(false);

  const { assessmentPopupData } = useSelector((state) => state.assessmentPopup);
  const [selection, setSelection] = React.useState("");

  const [filteredUnit, setFilteredUnit] = useState();
  const [filteredTypologies, setFilteredTypologies] = useState();
  const [filteredBuildingArea, setFilteredBuildingArea] = useState();
  const [filteredDesignStages, setFilteredDesignStages] = useState();
  const [disableProjectTarget, setDisableProjectTarget] = useState(false);
  const [disableTargetPercent, setDisableTargetPercent] = useState(false);
  const [isCsvOption, setIsCsvOption] = useState(false);
  const [workspaceData, setWorkspaceData] = useState({});

  const [assessmentFormData, setAssessmentFormData] = useState({
    project_name: "",
    region: "",
    address: "",
    project_manager: "",
    business_unit: assessmentPopupData.business_unit,
    contract_type: "",
    project_type: assessmentPopupData.project_type,
    structural_design_options: "",
    structural_height: "",
    construction_start_date: "",
    construction_end_date: "",
    project_target_carbon_intensity: null,
    project_target_carbon_reduction_percentage: null,
    selection: "",
    building_area: null,
    design_stages: "",
    external_parking_area: null,
    basement_levels: "",
    status: "Draft",
    csv_data: {},
  });
  const [formattedBuildingArea, setFormattedBuildingArea] = useState("");
  const [formattedExternalParkingArea, setFormattedExternalParkingArea] =
    useState("");
  const [
    formattedCarbonReductionPercentage,
    setFormattedCarbonReductionPercentage,
  ] = useState("");

  const [errors, setErrors] = useState({});
  const [radioGroupBlock, setRadioGroupBlock] = useState("none");
  const [loading, setLoading] = useState(false);

  const validateValues = (inputValues) => {
    let temp = {};
    temp.projectName = assessmentFormData.project_name
      ? ""
      : "Project Name is required";
    temp.region = assessmentFormData.region ? "" : "Region is required";
    temp.projectManager = assessmentFormData.project_manager
      ? ""
      : "Project Manager is required";
    temp.address = assessmentFormData.address ? "" : "Address is required";
    temp.structural_design_options =
      assessmentFormData.structural_design_options
        ? ""
        : "Structural Design Options is required";
    temp.structural_height = assessmentFormData.structural_height
      ? ""
      : "Structural Height is required";
    temp.projectType = assessmentFormData.project_type
      ? ""
      : "Project Type is required";
    temp.startDate = assessmentFormData.construction_start_date
      ? ""
      : "Construction Start Date is required";
    temp.endDate = assessmentFormData.construction_end_date
      ? ""
      : "Construction End Date is required";
    temp.selection = assessmentFormData.selection
      ? ""
      : "Selection of any One Above Options is required";

    setErrors({
      ...temp,
    });
    return Object.values(errors).every((x) => x == "");
  };

  useEffect(() => {
    dispatch(assessmentPopupCall(accessToken));
  }, []);

  const toggleLoading = (isLoading) => {
    setLoading(isLoading);
  };
  useEffect(() => {
    if (assessmentFormData.region && open) {
      const filteredRegion = assessmentPopupData.region.filter((data) =>
        data.includes(assessmentFormData.region)
      );

      const businessUnitObj = assessmentPopupData.business_unit;
      const typologiesObj = assessmentPopupData.project_type;

      let filteredBusinessUnit = [];
      let filteredTypologies = [];
      for (const region in businessUnitObj) {
        if (filteredRegion == region) {
          filteredBusinessUnit = businessUnitObj[region];
        }
      }
      for (const region in typologiesObj) {
        if (filteredRegion == region) {
          filteredTypologies = typologiesObj[region];
        }
        setFilteredUnit(filteredBusinessUnit);
        setFilteredTypologies(filteredTypologies);
      }

      // building area
      const buildingArea = assessmentPopupData.building_area_uom;
      let buildingAreaPlaceHolder = "";
      for (const area in buildingArea) {
        if (filteredRegion == area) {
          buildingAreaPlaceHolder = buildingArea[area];
        }
      }
      setFilteredBuildingArea(buildingAreaPlaceHolder);

      // design stages
      const designStages = assessmentPopupData.design_stages;
      let selectedStage = [];
      for (const stage in designStages) {
        if (filteredRegion == stage) {
          selectedStage = designStages[stage];
        }
      }
      setFilteredDesignStages(selectedStage);
    }
  }, [
    assessmentFormData.region,
    assessmentFormData.business_unit,
    assessmentFormData.project_type,
    assessmentFormData.building_area,
    assessmentFormData.design_stages,
    assessmentFormData.external_parking_area,
  ]);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = (e) => {
    if (e.target.value === "Cancel") {
      setAssessmentFormData({});
      setFormattedCarbonReductionPercentage("");
      setSelection("");
      setErrors({});
      setOpen(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateValues()) {
      if (!isCsvOption) {
        setAssessmentFormData({
          ...assessmentFormData,
          csv_data: {},
        });
      }
      const url = NEWASSESSMENTPOPUP_URL;
      const formData = new FormData();
      Object.keys(assessmentFormData).forEach((key) => {
        (assessmentFormData[key] == 0 || assessmentFormData[key]) &&
          formData.append(key, assessmentFormData[key]);
      });
      formData.append("status", "Draft");
      const config = {
        headers: {
          "x-api-key": process.env.REACT_APP_API_KEY,
          "content-type": "multipart/form-data",
          //Authorization: accessToken ? `Bearer ${accessToken}` : "",
        },
      };
      toggleLoading(true);
      axios
        .post(url, formData, config)
        .then((response) => {
          const data = response.data;
          sessionStorage.setItem("assessmentId", data.assessment_unique_id);
          if (response.status == 200) {
            setWorkspaceData(data.workspace_data);
            dispatch(
              setNewAssessmentData(
                {
                  assessementId: data.assessment_unique_id,
                  projectName: assessmentFormData.project_name,
                  region: assessmentFormData.region,
                  address: assessmentFormData.address,
                  projectManager: assessmentFormData.project_manager,
                  businessUnit: assessmentFormData.business_unit,
                  contractType: assessmentFormData.contract_type,
                  projectType: assessmentFormData.project_type,
                  structural_design_options:
                    assessmentFormData.structural_design_options,
                  structural_height: assessmentFormData.structural_height,
                  startData: assessmentFormData.construction_start_date,
                  endDate: assessmentFormData.construction_end_date,
                  projectTarget:
                    assessmentFormData.project_target_carbon_intensity
                      ? assessmentFormData.project_target_carbon_intensity
                      : assessmentFormData.project_target_carbon_reduction_percentage,
                  date: "", // will confirm with business
                  buildingArea: assessmentFormData.building_area,
                  selection: assessmentFormData.selection,
                },
                accessToken
              )
            );
            dispatch(setWorkspaceInitialData(data));
            dispatch(setIsNewAssessment(true));
            dispatch(setFinalWorkspaceData([]));
            dispatch(setWorkspaceDataSaveSuccess());
            navigate("/workspace");
          }
        })
        .catch((error) => {
          <ErrorHandler error={error} />;
        })
        .finally(() => {
          toggleLoading(false); // Hide the loader
        });
    }
  };

  const childData = (data) => {
    setAssessmentFormData({
      ...assessmentFormData,
      csv_data: JSON.stringify(data),
    });
  };

  const getRegionForDownloadUrl = (region) => {
    let region_code = "";
    switch (region) {
      case "Australia":
        region_code = "AU";
        break;
      case "United States":
        region_code = "US";
        break;
      case "Europe":
        region_code = "EU";
        break;
      case "Asia":
        region_code = "AS";
        break;
    }
    return region_code;
  };

  const exportToCSV = async () => {
    const region = assessmentFormData.region;
    const region_code = getRegionForDownloadUrl(region);
    try {
      const response = await axios.get(
        "/BoQ Upload Template_" + region_code + ".xlsx",
        {
          responseType: "arraybuffer",
        }
      );

      const blob = new Blob([response.data], {
        type: "application/octet-stream",
      });

      saveAs(blob, "BoQ Upload Template_" + region_code + ".xlsx");
    } catch (error) {
      console.log(error);
    }
  };

  const handleChange = (event) => {
    let InputValue = event.target.value;
    if (event.target.name == "region" && event.target.value) {
      setFormattedBuildingArea("");
      setFormattedExternalParkingArea("");
    }
    if (event.target.name == "selection" && event.target.value == "use_csv") {
      setIsCsvOption(true);
    } else {
      setIsCsvOption(false);
    }
    if (
      event.target.name == "project_target_carbon_intensity" &&
      event.target.value
    ) {
      setDisableTargetPercent(true);
    } else {
      setDisableTargetPercent(false);
    }
    if (event.target.name == "project_target_carbon_reduction_percentage") {
      let carbonReductionPercent = event.target.value;
      carbonReductionPercent = carbonReductionPercent.replace(/[^0-9]/g, "");
      let numericValue = parseInt(carbonReductionPercent);
      if (isNaN(numericValue) || numericValue < 0) {
        numericValue = null;
      } else if (numericValue > 100) {
        event.target.value =
          assessmentFormData.project_target_carbon_reduction_percentage;
        return;
      }

      if (event.nativeEvent.inputType === "deleteContentBackward") {
        setFormattedCarbonReductionPercentage(numericValue);
      } else {
        setFormattedCarbonReductionPercentage(numericValue + "%");
      }

      InputValue = numericValue;
    }
    if (
      event.target.name == "project_target_carbon_reduction_percentage" &&
      event.target.value
    ) {
      setDisableProjectTarget(true);
    } else {
      setDisableProjectTarget(false);
    }

    // append unit on building area and on external parking area
    if (
      event.target.name == "building_area" ||
      event.target.name == "external_parking_area"
    ) {
      let bulidingAreaValue = event.target.value;
      bulidingAreaValue = bulidingAreaValue.replace(/\s*(m2|ft2)/g, "");

      const isBackspaceOrDelete =
        event.nativeEvent.inputType === "deleteContentBackward";

      if (isBackspaceOrDelete) {
        if (event.target.name == "building_area") {
          setFormattedBuildingArea(bulidingAreaValue);
        } else {
          setFormattedExternalParkingArea(bulidingAreaValue);
        }
        InputValue = bulidingAreaValue;
      } else {
        bulidingAreaValue = bulidingAreaValue.replace(/\s/g, "");
        const valueWithUnit = bulidingAreaValue
          ? `${bulidingAreaValue} ${filteredBuildingArea}`
          : "";
        if (event.target.name == "building_area") {
          setFormattedBuildingArea(valueWithUnit);
        } else {
          setFormattedExternalParkingArea(valueWithUnit);
        }
        InputValue = bulidingAreaValue;
      }
    }

    setAssessmentFormData({
      ...assessmentFormData,
      [event.target.name]: InputValue,
    });
  };

  return (
    <div>
      <Backdrop open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Button
        variant="contained"
        color="primary"
        style={{
          backgroundColor: "#1C96A3",
          textTransform: "capitalize",
          float: "right",
          margin: "0px",
        }}
        sx={{ mt: 3, mb: 2, width: 215 }}
        onClick={handleOpen}
      >
        Start New Assessment
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Start new assessment
          </Typography>
          <Box sx={{ mt: 2 }}>
            <InputLabel id="demo-simple-select-label" required sx={{ mb: 2 }}>
              Project Name
            </InputLabel>
            <TextField
              fullWidth
              id="outlined"
              name="project_name"
              value={assessmentFormData.project_name}
              onChange={handleChange}
              helperText={errors.projectName}
              error={errors.projectName ? true : false}
            />
          </Box>
          <Box sx={{ mt: 2 }}>
            <InputLabel id="demo-simple-select-label" required sx={{ mb: 2 }}>
              Region
            </InputLabel>

            {assessmentPopupData.region != null &&
              assessmentPopupData.region.length > 0 && (
                <FormControl fullWidth {...(errors.region && { error: true })}>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="region"
                    value={assessmentFormData.region}
                    //label="Region"
                    // defaultValue={assessmentPopupData.region[0]}
                    onChange={handleChange}
                    //helperText = {errors.region}
                    error={errors.region ? true : false}
                  >
                    {assessmentPopupData.region.map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>{errors.region}</FormHelperText>
                </FormControl>
              )}
          </Box>
          <Box sx={{ mt: 2 }}>
            <InputLabel id="demo-simple-select-label" required sx={{ mb: 2 }}>
              Address
            </InputLabel>
            <TextField
              fullWidth
              id="outlined"
              placeholder="address"
              name="address"
              onChange={handleChange}
              helperText={errors.address}
              error={errors.address ? true : false}
            />
          </Box>
          <Box sx={{ mt: 2 }}>
            <InputLabel id="demo-simple-select-label" required sx={{ mb: 2 }}>
              Project Manager
            </InputLabel>
            <TextField
              fullWidth
              id="outlined-required"
              //label="Project Manager"
              name="project_manager"
              onChange={handleChange}
              helperText={errors.projectManager}
              error={errors.projectManager ? true : false}
            />
          </Box>
          {filteredUnit && (
            <Box sx={{ mt: 2 }}>
              <InputLabel id="demo-simple-select-label" sx={{ mb: 2 }}>
                Business Unit
              </InputLabel>
              <Select
                fullWidth
                labelId="demo-simple-select-label"
                id="business_unit"
                name="business_unit"
                value={assessmentFormData.business_unit}
                //label="Business Unit"
                // defaultValue={assessmentPopupData.region[0]}
                onChange={handleChange}
              >
                {filteredUnit.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </Box>
          )}
          <Box sx={{ mt: 2 }}>
            <InputLabel id="demo-simple-select-label" sx={{ mb: 2 }}>
              Contract Type
            </InputLabel>
            {assessmentPopupData.contract_type != null &&
              assessmentPopupData.contract_type.length > 0 && (
                <Select
                  fullWidth
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  name="contract_type"
                  value={assessmentFormData.contract_type}
                  //label="Contract Type"
                  // defaultValue={assessmentPopupData.contract_type[0]}
                  onChange={handleChange}
                >
                  {assessmentPopupData.contract_type.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </Select>
              )}
          </Box>
          {filteredTypologies && (
            <Box sx={{ mt: 2 }}>
              <InputLabel id="demo-simple-select-label" required sx={{ mb: 2 }}>
                Project Type
              </InputLabel>
              <FormControl
                fullWidth
                {...(errors.projectType && { error: true })}
              >
                <Select
                  labelId="demo-simple-select-label"
                  id="project_type"
                  name="project_type"
                  value={assessmentFormData.project_type}
                  //defaultValue={assessmentPopupData.region[0]}
                  onChange={handleChange}
                >
                  {filteredTypologies.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>{errors.projectType}</FormHelperText>
              </FormControl>
            </Box>
          )}
          <Box sx={{ mt: 2 }}>
            <InputLabel id="demo-simple-select-label" required sx={{ mb: 2 }}>
              Structural Design Options
            </InputLabel>
            {assessmentPopupData.structural_design_options != null &&
              assessmentPopupData.structural_design_options.length > 0 && (
                <FormControl
                  fullWidth
                  {...(errors.structural_design_options && { error: true })}
                >
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="structural_design_options"
                    value={assessmentFormData.structural_design_options}
                    label="Structural Design Options"
                    // defaultValue={
                    //   assessmentPopupData.structural_design_options[0]
                    // }
                    onChange={handleChange}
                  >
                    {assessmentPopupData.structural_design_options.map(
                      (option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      )
                    )}
                  </Select>
                  <FormHelperText>
                    {errors.structural_design_options}
                  </FormHelperText>
                </FormControl>
              )}
          </Box>
          <Box sx={{ mt: 2 }}>
            <InputLabel id="demo-simple-select-label" required sx={{ mb: 2 }}>
              Structural Height
            </InputLabel>
            {assessmentPopupData.structural_height != null &&
              assessmentPopupData.structural_height.length > 0 && (
                <FormControl
                  fullWidth
                  {...(errors.structural_height && { error: true })}
                >
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="structural_height"
                    value={assessmentFormData.structural_height}
                    label="Structural Heights"
                    // defaultValue={assessmentPopupData.structural_height[0]}
                    onChange={handleChange}
                  >
                    {assessmentPopupData.structural_height.map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>{errors.structural_height}</FormHelperText>
                </FormControl>
              )}
          </Box>
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <InputLabel
                  id="demo-simple-select-label"
                  required
                  sx={{ mt: 2 }}
                >
                  Construction Start Date
                </InputLabel>
              </Grid>
              <Grid item xs={6}>
                <InputLabel
                  id="demo-simple-select-label"
                  required
                  sx={{ mt: 2 }}
                >
                  Construction End Date
                </InputLabel>
              </Grid>
            </Grid>
          </Box>
          <Box sx={{ mt: 2 }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={["DatePicker", "DatePicker"]}>
                <FormControl {...(errors.startDate && { error: true })}>
                  <DatePicker
                    label="Construction Start Date"
                    selected={assessmentFormData.construction_start_date}
                    onChange={(newValue) => {
                      const date = new Date(newValue);

                      const formattedDate = format(date, "dd/MM/yyyy");

                      setAssessmentFormData({
                        ...assessmentFormData,
                        construction_start_date: formattedDate,
                      });
                    }}
                  />
                  <FormHelperText>{errors.startDate}</FormHelperText>
                </FormControl>
                <FormControl {...(errors.endDate && { error: true })}>
                  <DatePicker
                    label="End Date"
                    onChange={(newValue) => {
                      const date = new Date(newValue);

                      const formattedDate = format(date, "dd/MM/yyyy");

                      setAssessmentFormData({
                        ...assessmentFormData,

                        construction_end_date: formattedDate,
                      });
                    }}
                  />
                  <FormHelperText>{errors.endDate}</FormHelperText>
                </FormControl>
              </DemoContainer>
            </LocalizationProvider>
          </Box>
          {filteredBuildingArea && (
            <Box sx={{ mt: 2 }}>
              <InputLabel required id="demo-simple-select-label" sx={{ mb: 2 }}>
                Building Area
              </InputLabel>
              <TextField
                fullWidth
                id="outlined"
                name="building_area"
                placeholder={filteredBuildingArea}
                onChange={handleChange}
                onKeyDown={(ev) => {
                  numericValidation(ev);
                }}
                value={formattedBuildingArea}
              />
            </Box>
          )}
          <Box sx={{ mt: 2 }}>
            <InputLabel id="demo-simple-select-label" sx={{ mb: 2 }}>
              Client required/ Regulated target Carbon Intensity
            </InputLabel>
            <TextField
              fullWidth
              id="outlined"
              label="Project Target kgCO2-eq/GFA (or GIA)"
              name="project_target_carbon_intensity"
              disabled={disableProjectTarget}
              onChange={handleChange}
              onKeyDown={(ev) => {
                numericValidation(ev);
              }}
            />
          </Box>
          <Box sx={{ mt: 2 }}>
            <InputLabel id="demo-simple-select-label" sx={{ mb: 2 }}>
              Client Required / Regulated target Carbon reduction percentage
            </InputLabel>
            <TextField
              fullWidth
              id="outlined"
              name="project_target_carbon_reduction_percentage"
              placeholder="Enter value between (0-100)%"
              disabled={disableTargetPercent}
              onChange={handleChange}
              onKeyDown={(ev) => {
                numericValidation(ev);
              }}
              value={formattedCarbonReductionPercentage}
            />
          </Box>

          {filteredDesignStages && (
            <Box sx={{ mt: 2 }}>
              <InputLabel id="demo-simple-select-label" sx={{ mb: 2 }}>
                Design Stage
              </InputLabel>
              <Select
                fullWidth
                labelId="demo-simple-select-label"
                id="design_stages"
                name="design_stages"
                value={assessmentFormData.design_stages}
                //defaultValue={assessmentPopupData.region[0]}
                onChange={handleChange}
              >
                {filteredDesignStages.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </Box>
          )}
          {filteredBuildingArea && (
            <Box sx={{ mt: 2 }}>
              <InputLabel id="demo-simple-select-label" sx={{ mb: 2 }}>
                External parking area
              </InputLabel>
              <TextField
                fullWidth
                id="outlined"
                name="external_parking_area"
                value={formattedExternalParkingArea}
                onChange={handleChange}
                placeholder={filteredBuildingArea}
                onKeyDown={(ev) => {
                  numericValidation(ev);
                }}
              />
            </Box>
          )}
          <Box sx={{ mt: 2 }}>
            <InputLabel id="demo-simple-select-label" sx={{ mb: 2 }}>
              Number of basement levels
            </InputLabel>
            {assessmentPopupData.basement_levels != null &&
              assessmentPopupData.basement_levels.length > 0 && (
                <Select
                  fullWidth
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  name="basement_levels"
                  value={assessmentFormData.basement_levels}
                  onChange={handleChange}
                >
                  {assessmentPopupData.basement_levels.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </Select>
              )}
          </Box>
          <Box sx={{ mt: 2 }}>
            <div>
              <span>Starting Point</span>
              <span style={{ color: "red", fontSize: "23px" }}>* </span>
            </div>

            <Typography sx={{ fontSize: "12px" }}>
              How would you like to start your assessment?
            </Typography>
            <FormControl {...(errors.selection && { error: true })}>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                //defaultValue="use_csv"
                name="selection"
                onChange={handleChange}
                value={assessmentFormData.selection}
              >
                <FormControlLabel
                  value="use_benchmark"
                  control={<Radio />}
                  label="Pre-populate with benchmark data"
                />
                <FormControlLabel
                  value="use_blank_canvas"
                  control={<Radio />}
                  label="Enter data manually"
                />
                {assessmentFormData.region && (
                  <FormControlLabel
                    value="use_csv"
                    control={<Radio />}
                    label="Upload data in excel template"
                  />
                )}
              </RadioGroup>
              <FormHelperText>{errors.selection}</FormHelperText>
            </FormControl>
          </Box>
          {assessmentFormData.region && isCsvOption && (
            <Box>
              <Typography sx={{ fontSize: "12px", fontWeight: "600", mt: 2 }}>
                Excel Template
              </Typography>
              <Typography
                sx={{ fontSize: "12px", fontStyle: "italic", mt: 2, mb: 2 }}
              >
                Uploading the excel document will allow the system to
                pre-populate the tool with relevant data. If you do not have the
                correct Excel template you may download it here.
              </Typography>
              <Typography sx={{ fontWeight: "bold", fontSize: "12px" }}>
                Caution: Please ensure that you upload an Excel file
                specifically relevant to your region.
              </Typography>
              <Button
                style={{
                  border: "1px solid #23B4C3",
                  color: "#23B4C3",
                  textTransform: "capitalize",
                  marginBottom: "10px",
                  marginTop: "15px",
                }}
                onClick={exportToCSV}
              >
                <DownloadIcon />
                Download Template
              </Button>

              <FileUploader childData={childData} />
            </Box>
          )}
          <DialogActions style={{ justifyContent: "space-between" }}>
            <Button
              style={{
                float: "left",
                border: "1px solid #23B4C3",
                color: "#23B4C3",
                textTransform: "capitalize",
                width: "12rem",
              }}
              value="Cancel"
              onClick={handleClose}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="success"
              style={{
                backgroundColor: "#1C96A3",
                textTransform: "capitalize",
                width: "12rem",
              }}
              sx={{ float: "right" }}
              onClick={handleSubmit}
            >
              Start Assessment
            </Button>
          </DialogActions>
        </Box>
      </Modal>
    </div>
  );
};
export default NewAssessmentPopup;
